import React, { useEffect } from 'react';
import { createEvent } from 'effector';
import useToggle from '@hooks/useToggle';

export const toggleSunlightTip = createEvent<boolean>();

export function SunlightTip() {
  const { isOn, set } = useToggle(false);
  useEffect(() => {
    return toggleSunlightTip.watch(set);
  }, []);
  if (!isOn) return null;
  return (
    <div className="absolute mb-130 flex h-35 select-none items-center rounded bg-orange px-10 text-white">
      拖动可调整太阳光位置
    </div>
  );
}
